import React, { useEffect } from "react"
import { injectIntl } from "react-intl"
import { useDispatch, useSelector } from "react-redux"
import Select from "react-select"
import { FilterStatusOption, StockDocumentStatusSelectProps } from "../../common/types/inventory"
import IntlProps from "../../state/helpers/IntlProps"
import {
    InventoryStockDocumentDefinitionAction,
    InventoryStockDocumentDefinitionSelector
} from "../../state/inventory"
import { sortStatusOptions } from "../../utils/inventory/utils"

const CustomStockDocumentStatusSelect = (props: StockDocumentStatusSelectProps & IntlProps) => {
    const dispatch = useDispatch()
    const definitionListing = useSelector(InventoryStockDocumentDefinitionSelector.getListing)

    useEffect(() => {
        dispatch(InventoryStockDocumentDefinitionAction.fetchListing())
    }, [])

    const onStatusChange = (newStatusIds) => {
        if (newStatusIds) {
            props.onStatusChange(newStatusIds?.map(option => {
                return option.value
            }), newStatusIds?.map(option => {
                return option.label
            }).join(", "))
        } else {
            props.onStatusChange("", "")
        }
    }

    const mapOptions = () => {
        const statusArray: FilterStatusOption[] = []
        definitionListing?.forEach(doc => {
            const labelPrefix = doc.name
            doc.statuses.forEach(s => {
                const opLabel = s.attributes.name + ` (${labelPrefix})`
                const opId = s.id
                statusArray.push({ label: opLabel, value: opId })
            })
        })
        return statusArray
    }

    return <Select
        disabled={false}
        clearable={true}
        multi={true}
        options={sortStatusOptions(mapOptions())}
        value={props.customStatusIds}
        onChange={(option) => {
            onStatusChange(option)
        }}
    />
}

export default injectIntl(CustomStockDocumentStatusSelect)


// WEBPACK FOOTER //
// ./src/inventory/components/SelectComponent.tsx